export const buildThemeClasses = (theme: string) => ({
  "theme--dark-green": theme === "Dark green",
  "theme--light-green": theme === "Light green",
  "theme--green": theme === "Green",
  "theme--blush": theme === "Blush",
  "theme--white": theme === "White" || theme === "Default" || theme === "Not set",
  "theme--light-blue": theme === "Light blue",
  "theme--blue": theme === "Blue",
  "theme--dark-blue": theme === "Dark blue",
  "theme--amber": theme === "Amber",
  "theme--amber-light": theme === "Amber light",
  // special case for duplex in tabs
  "theme--passthrough": theme === "Passthrough",
});

export const getChildThemeForDuplex = (theme: string) => {
  switch (theme) {
    case "Dark green":
    case "Green":
      return "Blush";
    case "Dark blue":
    case "Blue":
      return "Light blue";
    default:
      return "Passthrough";
  }
}
